import { render, staticRenderFns } from "./ServerCommands.vue?vue&type=template&id=c5b98714&scoped=true"
import script from "./ServerCommands.vue?vue&type=script&lang=ts"
export * from "./ServerCommands.vue?vue&type=script&lang=ts"
import style0 from "./ServerCommands.vue?vue&type=style&index=0&id=c5b98714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b98714",
  null
  
)

export default component.exports